import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Review } from '../components/api2';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../pages/style.css";
// import logo from '../logo192.png';

const ReviewUser = () => {
    const navigate = useNavigate();
    const [yourName, setYourName] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [phone, setPhone] = useState("");
    const [Email, setEmail] = useState("");
    const [Password, setPassword] = useState("");
    const [ConfirmPassword, setConfirmPassword] = useState("");

    // const hasValNumber = /^[0-9]{1,10}$/.test(phone);
    const hasValNumber = /^[6-9]\d{9}$/.test(phone);

    // const restrictedDomains = ['aol.com'];

    // const isBusinessEmail = (email) => {
    //     const domain = email.split('@')[1];
    //     return domain && !restrictedDomains.includes(domain.toLowerCase());
    // };

    const emailRegex = /^[a-zA-Z0-9._%+-]+@(?!(?:.*\.\.)|.*\.$)[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    const hasValEmail = emailRegex.test(Email);

    const [loading, setLoading] = useState(false);
    // const isValidPassword = /^(?=.*\d).{5,}$/.test(Password);
    const isValidPassword = /^(?=.*[0-9]).{5,}$/.test(Password);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const capitalizeWords = (name) => {
        return name
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };
    // const handleSignup = async (e) => {
    //     e.preventDefault();
    //     setLoading(true); // Start loader
    //     try {
    //         const formattedName = capitalizeWords(yourName);
    //         const res = await Review({ yourName: formattedName, email: Email, password: Password, phone });
    //         if (res.error) {
    //             toast.error(res.error);
    //         } else {
    //             toast.warning("Enter your OTP");
    //             navigate('/otp-review', { replace: true, state: { email: Email } });
    //         }
    //     } catch (error) {
    //         // Handle other errors
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const handleSignup = async (e) => {
        e.preventDefault();

        if (!isValidPassword) {
            toast.error("Password must be at least 5 characters long and contain one number.");
            return;
        }

        setLoading(true);
        try {
            const formattedName = capitalizeWords(yourName);
            const res = await Review({ yourName: formattedName, email: Email, password: Password, phone });
            if (res.error) {
                toast.error(res.error);
            } else {
                toast.warning("Enter your OTP");
                navigate('/otp-review', { replace: true, state: { email: Email } });
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='thank-you-container'>
            {/* {loading && (
                <div className="loader-overlay">
                    <div className="loader"></div>
                </div>
            )} */}
            <div className='control my-input' style={{ marginLeft: "29rem" }}>
                <h1 className='title has-text-white'>Sign Up </h1>
                <div className='form-container'>
                    <form>
                        <div className=' has-text-left my-input'>
                            <label className='label has-text-white ml-4'>Your Name</label>
                        </div>
                        <div className='field'>
                            <div className="control has-icons-left ">
                                <div className='column'>
                                    <input
                                        className="input is-rounded"
                                        type="text"
                                        placeholder="e.g. Naresh kumar"
                                        value={yourName}
                                        onChange={(e) => setYourName(e.target.value)}
                                        maxLength={50}
                                    />
                                    <span className='icon is-small is-left my-3 ml-3'>
                                        <i className='fas fa-rocket'></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className=' has-text-left '>
                            <label className='label has-text-white ml-4'>Mobile Number</label>
                        </div>
                        <div className='field'>
                            <div className="control has-icons-left my-input">
                                <div className='column'>
                                    <input
                                        className="input is-rounded"
                                        type="text"
                                        placeholder="9898989898"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                    {phone && !hasValNumber && (
                                        <div>
                                            <small className={`ml-1  ${!hasValNumber && phone !== '' ? 'has-text-danger' : 'has-text-success'}`}>
                                                {!hasValNumber && phone !== '' ? 'Please Enter valid 10 digit Indian Mobile number without 0/+91' : ''}
                                            </small>
                                        </div>
                                    )}
                                    <span className='icon is-small is-left  my-3 ml-3'>
                                        <i className='fas fa-phone'></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className='has-text-left '>
                            <label className='label has-text-white ml-4'>Your Email</label>
                        </div>
                        <div className='field'>
                            <div className="control has-icons-left my-input">
                                <div className='column'>
                                    <input
                                        className="input is-rounded"
                                        type="text"
                                        placeholder="naresh.kumar@hobo.video"
                                        value={Email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {Email && !hasValEmail && (
                                        <small className={`ml-1  ${!hasValEmail && Email !== '' ? 'has-text-danger' : 'has-text-success'}`}>
                                            {!hasValEmail && Email !== '' ? 'Enter a valid email address' : ''}
                                        </small>
                                    )}
                                    <span className="icon is-small is-left my-3 ml-3">
                                        <i className="fas fa-envelope"></i>
                                    </span>

                                </div>
                            </div>
                        </div>

                        <div className='my-2 has-text-left my-input'>
                            <label className='label has-text-white'>Password</label>
                        </div>
                        <div className='field'>
                            <div className="control has-icons-left has-icons-right is-flex my-input">
                                <input
                                    className="input is-rounded"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Password"
                                    value={Password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    maxLength={50}
                                />
                                <span className="icon is-small is-left">
                                    <i className="fas fa-key"></i>
                                </span>
                                <span className="icon is-small is-right" onClick={togglePasswordVisibility} style={{ cursor: 'pointer', 'pointer-events': 'all' }}>
                                    <i className={`fas fa-eye${showPassword ? '-slash' : ''}`}></i>
                                </span>
                            </div>
                            {Password && !isValidPassword && (
                                <small className="has-text-danger">
                                    Password must be at least 5 characters long and contatin one numerical digit.
                                </small>
                            )}

                        </div>
                        <div className='is-flex has-text-left mr-5 mt-4 my-input'>
                            <p className="has-text-white"> Have an account?</p>
                            <Link to='/review-login'>
                                <span className='has-text-weight-bold ml-2'>Sign In</span>
                            </Link>
                        </div>
                        <div className='Link mb-2'>
                            <Link to='/forgot-review'>
                                <p className='has-text-right my-input'>Forgot Your Password?</p>
                            </Link>
                        </div>
                        <div className="field">
                            <div className="control my-input">
                                <div className="field">
                                    <div className="control my-input">
                                        <Link to="/otp">
                                            <button
                                                className="button has-text-white is-primary is-rounded is-focused is-medium is-fullwidth"
                                                disabled={!yourName || !phone || !Email || !Password || loading || !hasValNumber || !hasValEmail || !isValidPassword}
                                                onClick={handleSignup}
                                            >
                                                {loading ? (
                                                    <div className="loader"></div> // Loader
                                                ) : (
                                                    'Sign Up'
                                                )}
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ReviewUser;

